import { EntityList } from '@/common/entityFramework/entityList/EntityList'
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback } from 'react'

export const McoInvFileList = ({ mcoInvId }) => {
  
  const augRowsReq = useCallback((rowsReq) => {
    if (!mcoInvId) return;
    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('entityId', mcoInvId, 'entity', 'MCO_INV'));
  }, [mcoInvId]);

  return (
    <EntityList entity="ENTITY_FILE" augRowsReq={augRowsReq}/>
  )
}